// extend already existing `quattro.config`
angular.module('quattro.config')
.constant('api_url', 'https://api.mx.heinlein-hosting.de/')
.constant('bmbo_api_url', 'https://api.mailbox.org/v1/');
